import React from 'react';
import { disconnectWallet, connectWallet} from './helpers/wallet.js'
import { AccountName } from './accountName.js';
import orlsvg from '../images/ORL_logo.svg';
import reeflogo from '../images/banner_text.png';


function TopNav ({walletAddress, setWallet, status, setStatus, setModalInfo, setMessage, accountName, setAccountName}) {

    const connectWalletPressed = async () => {
        
        if (walletAddress === ''){
            await connectToWallet();
        }else{
            const disconnReponse = await disconnectWallet();
            setStatus(disconnReponse.status);
            await setWallet(disconnReponse.address);
        }
      };

      const connectToWallet = async () => {
        const walletResponse = await connectWallet();
        setStatus(walletResponse.status);
        await setWallet(walletResponse.address);
      }

     
    
        if (window.ethereum){
          window.ethereum.on("chainChanged", (chainId) => {
            /* do what you want here */
            /* full refresh is recommended */
            console.log(chainId);
            const checkWallet = async() => {
                await connectToWallet();
              }
              checkWallet();
            
            })

            window.ethereum.on("accountsChanged", (accounts) => {
              /* do what you want here */
    //          console.log(accounts);
              const checkWallet = async() => {
                await connectToWallet();
              }
              checkWallet();
              })
        }
        

    return <nav className="navbar navbar-expand-sm" aria-label="Third navbar example" id="topNavBar" style={{backgroundColor:'rgb(0,0,0,.3)'}}>
        <div className="container-fluid">
            <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarsExample03" aria-controls="navbarsExample03" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>

            <div className="navbar-collapse collapse" id="navbarsExample03">
                <ul className="navbar-nav me-auto mb-2 mb-sm-0">
                    <li className="nav-item" style={{marginLeft:'5%'}}>
                    <img src={orlsvg} alt="orl logo" className="orlimage" style={{width:'90px'}} />
                    </li>
                    <li className="nav-item" style={{paddingLeft:'10px', marginTop:'auto', marginBottom:'auto'}}>
                    <img src={reeflogo} alt="orl logo" style={{width:'240px'}} />
                    </li>
                </ul>
                {status} <AccountName walletAddress={walletAddress} setMessage={setMessage} setModalInfo={setModalInfo} displayOnly={true} accountName={accountName} setAccountName={setAccountName} /><button id="walletButton" type="button" style={{marginRight:'5%'}}className={(walletAddress.length === 0 ? 'btn btn-light' : 'btn' )}  onClick={connectWalletPressed}>
        {walletAddress.length > 0 ? (
           <svg stroke="currentColor" fill="#ffffff" strokeWidth="0" viewBox="-2 -2 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"></path></svg>
        ) : (
          <span>Connect Wallet</span>
        )}
      </button>
            </div>
        </div>
    </nav>

}

export {TopNav};